/*
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited 2024.
 */

import { SvgIconProps } from '@mui/material';

export const productCardInventorySvgIconProps: SvgIconProps = {
	fontSize: 'small',
	color: 'disabled',
};
